import styled from 'styled-components';
import { Modal } from '../../../modal/modal-old.js';
import BinaryQuestion from '../../../binary-question.js';
import UpdateDisplayName from '../components/update-display-name.js';
import Checkbox from '../../../forms/checkbox';

const CheckboxContainer = styled.td`
	display: flex;
	justify-content: flex-end;
	.custom .custom__label:after {
		right: -2px;
	}
	.custom .custom__label:before {
		right: 0px;
	}
	.custom .custom__label {
		cursor: pointer;
	}
`;

const WeSpinGameRoomBuyInModal = ({
	adjustAmountQuestion,
	buyInQuestion,
	usernameQuestion,
	balanceCapMet,
	submitting,
	tr,
	proceedWithBuyIn,
	proceedToJoinFreeWeSpin,
	onCloseSidebar,
	onAdjustAmount,
	onNoAdjustClick,
	buyInBalance,
	newAmount,
	streamerName,
	currentGame,
	onNoClick,
	performBuyIn,
	showFreeWeSpinQuestion,
	joinFreeWeSpin,
	formattedStartDate,
	formattedStartTime,
	formattedEndTime,
	isFreeWeSpin,
	isReminderChecked = true,
	handleReminderCheckboxClick
}) => (
	<Modal
		show={
			adjustAmountQuestion ||
			buyInQuestion ||
			usernameQuestion ||
			balanceCapMet ||
			submitting ||
			showFreeWeSpinQuestion
		}
		position="fixed"
	>
		<>
			{submitting && (
				<div className="u-text-c u-relative u-width-100 u-height-100 u-center-vertically u-bg-overlay-70">
					<div className="spinner" />
				</div>
			)}
			{usernameQuestion && (
				<UpdateDisplayName onDone={isFreeWeSpin ? proceedToJoinFreeWeSpin : proceedWithBuyIn} />
			)}
			<div className="form">
				{balanceCapMet && (
					<BinaryQuestion
						shouldOpenBinary
						title={tr.WE_SPIN_BUY_IN_BALANCE_CAP_MET_TITLE}
						text={tr.WE_SPIN_BUY_IN_BALANCE_CAP_MET_TEXT}
						yesText={tr.WE_SPIN_BUY_IN_BALANCE_CAP_MET_BUTTON}
						onYesClick={onCloseSidebar}
						onOutsideClick={onCloseSidebar}
						openInSidebar
					/>
				)}
				{!balanceCapMet && (
					<>
						<BinaryQuestion
							shouldOpenBinary={adjustAmountQuestion}
							title={tr.WE_SPIN_BUY_IN_ADJUST_AMOUNT_TITLE}
							text={tr.WE_SPIN_BUY_IN_ADJUST_AMOUNT_TEXT}
							yesText={tr.WE_SPIN_BUY_IN_ADJUST_AMOUNT_CONFIRM}
							onYesClick={onAdjustAmount}
							noText={tr.WE_SPIN_BUY_IN_ADJUST_AMOUNT_CANCEL}
							onNoClick={onNoAdjustClick}
							onOutsideClick={onNoAdjustClick}
							openInSidebar
						>
							<div className="u-pt2">
								<table className="table--binary-question">
									<tbody>
										<tr>
											<td>{tr.WE_SPIN_BUY_IN_ADJUST_AMOUNT_CURRENT_BALANCE}</td>
											<td>{buyInBalance}</td>
										</tr>
										<tr>
											<td>{tr.WE_SPIN_BUY_IN_ADJUST_AMOUNT_NEW_AMOUNT}</td>
											<td>{newAmount}</td>
										</tr>
										<tr>
											<td>{tr.WE_SPIN_BUY_IN_REMINDER}</td>
											<CheckboxContainer>
												<Checkbox
													id="remind-me-checkbox"
													isChecked={isReminderChecked}
													onChange={handleReminderCheckboxClick}
													iconPosition="right"
												/>
											</CheckboxContainer>
										</tr>
									</tbody>
								</table>
							</div>
						</BinaryQuestion>
						<BinaryQuestion
							shouldOpenBinary={buyInQuestion}
							title={tr.WE_SPIN_BUY_IN_CONFIRM_TITLE}
							text={`${tr.WE_SPIN_BUY_IN_CONFIRM_MSG_ROW_ONE} ${streamerName} - ${currentGame?.gameName} ${tr.WE_SPIN_BUY_IN_CONFIRM_MSG_ROW_TWO}`}
							yesText={tr.WE_SPIN_BUY_IN_CONFIRM_BUTTON}
							onYesClick={performBuyIn}
							noText={tr.WE_SPIN_BUY_IN_CONFIRM_CANCEL_BUTTON}
							openInSidebar
							onNoClick={onNoClick}
							onOutsideClick={onNoClick}
						>
							<div className="u-pt2">
								<table className="table--binary-question">
									<tbody>
										<tr>
											<td>{tr.WE_SPIN_BUY_IN_BALANCE_LABEL}</td>
											<td>{buyInBalance}</td>
										</tr>
										<tr>
											<td>{tr.WE_SPIN_BUY_IN_REMINDER}</td>
											<CheckboxContainer>
												<Checkbox
													id="remind-me-checkbox"
													isChecked={isReminderChecked}
													onChange={handleReminderCheckboxClick}
													iconPosition="right"
												/>
											</CheckboxContainer>
										</tr>
									</tbody>
								</table>
							</div>
						</BinaryQuestion>
					</>
				)}
				{showFreeWeSpinQuestion && (
					<BinaryQuestion
						shouldOpenBinary={showFreeWeSpinQuestion}
						title={tr.WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TITLE}
						text={tr.WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TEXT}
						yesText={tr.WE_SPIN_BUY_IN_CONFIRM_BUTTON}
						onYesClick={joinFreeWeSpin}
						noText={tr.WE_SPIN_BUY_IN_CONFIRM_CANCEL_BUTTON}
						openInSidebar
						onNoClick={onNoClick}
						onOutsideClick={onNoClick}
					>
						<div className="u-pt2">
							<table className="table--binary-question">
								<tbody>
									<tr>
										<td>{tr.WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_DATE}</td>
										<td>{formattedStartDate}</td>
									</tr>
									<tr>
										<td>{tr.WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TIME}</td>
										<td>{`${formattedStartTime} - ${formattedEndTime}`}</td>
									</tr>
									<tr>
										<td>{tr.WE_SPIN_BUY_IN_REMINDER}</td>
										<CheckboxContainer>
											<Checkbox
												id="remind-me-checkbox"
												isChecked={isReminderChecked}
												onChange={handleReminderCheckboxClick}
												iconPosition="right"
											/>
										</CheckboxContainer>
									</tr>
								</tbody>
							</table>
						</div>
					</BinaryQuestion>
				)}
			</div>
		</>
	</Modal>
);

export default WeSpinGameRoomBuyInModal;
